import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Dropdown.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import arrowPng from './arrow.png';
import ReadOnlyInput from '../input/ReadOnlyInput';

class Dropdown extends Component {
  static propTypes = {
    className: PropTypes.string,
    clearable: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        label: PropTypes.string,
      })
    ).isRequired,
    placeholder: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    theme: PropTypes.string,
    valid: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        label: PropTypes.string,
      }),
    ]),
    onChange: PropTypes.func,
  };

  static defaultProps = {
    clearable: false,
    valid: true,
  };

  handleOnChange = (newOption) => {
    if (this.props.onChange !== undefined) {
      this.props.onChange(newOption);
    }
  };

  getLabelFromValue() {
    const element = this.props.options.find(
      (element) => element.value === this.props.value
    );
    return element !== undefined ? element.label : '';
  }

  render() {
    return this.props.readOnly ? (
      <ReadOnlyInput
        class={
          this.props.className !== undefined ? ' ' + this.props.className : ''
        }
        placeholder={this.props.placeholder}
        theme={this.props.theme}
        value={this.getLabelFromValue()}
      />
    ) : (
      <div
        className={
          'dropdown' +
          (this.props.className !== undefined
            ? ' ' + this.props.className
            : '') +
          (this.props.valid !== undefined && !this.props.valid
            ? ' invalid'
            : '')
        }
      >
        <Select
          arrowRenderer={() => {
            return <img src={arrowPng} alt={'arrow'} />;
          }}
          clearable={this.props.clearable}
          disabled={this.props.disabled}
          options={this.props.options.map((element) => {
            return {
              value: element.value,
              label: element.label,
            };
          })}
          placeholder={this.props.placeholder}
          value={this.props.value}
          searchable={false}
          onChange={this.handleOnChange}
        />
      </div>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/shared/dropdown/Dropdown.js